import { genders } from "@api/selectTypes/genders/path";
import { notificationKinds } from "@api/selectTypes/notificationKinds/path";
import { notificationLevel } from "@api/selectTypes/notificationLevel/path";
import { paymentMethods } from "@api/selectTypes/paymentMethods/path";
import { purchaseInvoicesStatus } from "@api/selectTypes/purchaseInvoicesStatus/path";
import { salesInvoicesStatus } from "@api/selectTypes/salesInvoicesStatus/path";
import { salesPriceKind } from "@api/selectTypes/salesPriceKind/path";
import { storeCostKinds } from "@api/selectTypes/storeCostKinds/path";
import { subscriptionStatus } from "@api/selectTypes/subscriptionStatus/path";
import { transactionKinds } from "@api/selectTypes/transactionKinds/path";
import { userRoles } from "@api/selectTypes/userRoles/path";
import { warehouseCirculationEventKinds } from "@api/selectTypes/warehouseCirculationEventKinds/path";
import { warehouseKinds } from "@api/selectTypes/warehouseKinds/path";

export const selectTypes = {
  genders,
  userRoles,
  subscriptionStatus,
  storeCostKinds,
  warehouseKinds,
  warehouseCirculationEventKinds,
  paymentMethods,
  salesInvoicesStatus,
  salesPriceKind,
  purchaseInvoicesStatus,
  transactionKinds,
  notificationKinds,
  notificationLevel,
};
